import { Children } from 'react';

import { ExpandableContent, ExpandableProvider } from './client';

export interface ExpandableProps extends React.ComponentPropsWithoutRef<typeof ExpandableProvider> {
  /**
   * The max number of items to show before expanding. If the number of links is less than the
   * limit, all links will be shown (and rendered on the server).
   */
  limit: number;

  /** Multiple items */
  children: React.ReactNode[];
}

export function Expandable({ limit, ctaText, children, ...rest }: ExpandableProps) {
  const arrayChildren = Children.toArray(children);

  return (
    <>
      {arrayChildren.length > limit ? (
        <ExpandableProvider ctaText={ctaText} {...rest}>
          {arrayChildren.slice(0, limit)}
          <ExpandableContent>{arrayChildren.slice(limit)}</ExpandableContent>
        </ExpandableProvider>
      ) : (
        arrayChildren
      )}
    </>
  );
}
